<template>
  <div ref="ie11hack">
    <div class="modal-header">
      <img v-if="hasImage" ref="ie11image" :src="imagePath" alt="" aria-hidden="true" class="logo" />
      <h2 class="h4 modal-title"><slot name="headline"/></h2>
    </div>
    <div class="modal-body">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modalinfo',

  props: {
    imagePath: {
      type: String,
      required: true,
    },
    hasImage: {
      type: Boolean,
      required: true,
    },
  },
  mounted() {
    if (!!window.MSInputMethodContext && !!document.documentMode) {
      // IE11
      // eslint-disable-next-line no-unused-expressions
      this.$refs.ie11hack.style;
      this.$refs.ie11image.style.height = '100%';
    }
  },
};
</script>

<style scoped>
.modal-header {
  display: flex;
  width: 100%;
}
.logo {
  max-width: 180px;
  max-height: 60px;
  margin-bottom: -60px;
  object-fit: contain;
}
.modal-title {
  flex-grow: 1;
}
</style>
